import * as Actions from './administrationActions';
import { AdministrationConstants } from './administrationConstants';

export function setSelectedTab(payload: number): Actions.SetActiveTab {
  return {
    type: AdministrationConstants.SET_ACTIVE_TAB,
    payload,
  };
}
